var _a, _b;
import { PlanTypeCategory } from '../../enum';
import { QueueStatusType } from './queue/types';
export var ALL_LOCATIONS_ID = -1;
export var MAX_TEXT_LENGTH = 35;
export var LocationTableEntryMode;
(function (LocationTableEntryMode) {
  LocationTableEntryMode["Percentage"] = "percentage";
  LocationTableEntryMode["Absolute"] = "absolute";
})(LocationTableEntryMode || (LocationTableEntryMode = {}));
// STEPS_LENGTH is now dynamic based on plan type category
// Use getStepsLength(planTypeCategory) instead
export var TIME_INTERVAL = [{
  id: 15,
  name: '15 min'
}, {
  id: 30,
  name: '30 min'
}, {
  id: 60,
  name: '60 min'
}];
export var WORK_TYPE_ICON = ['phone-arrow-down-left', 'phone-arrow-up-right', 'envelope', 'message-dots', 'message-sms', 'share-nodes', 'envelope-open-text', 'fax', 'files', 'square-list'];
export var WizardStep;
(function (WizardStep) {
  WizardStep[WizardStep["Queues"] = 0] = "Queues";
  WizardStep[WizardStep["WorkVolume"] = 1] = "WorkVolume";
  WizardStep[WizardStep["ProdHours"] = 2] = "ProdHours";
  WizardStep[WizardStep["HandleTime"] = 3] = "HandleTime";
  WizardStep[WizardStep["Shrinkage"] = 4] = "Shrinkage";
  WizardStep[WizardStep["Attrition"] = 5] = "Attrition";
  WizardStep[WizardStep["WorkingDays"] = 6] = "WorkingDays";
  WizardStep[WizardStep["SupportStaff"] = 7] = "SupportStaff";
  WizardStep[WizardStep["Financial"] = 8] = "Financial";
  WizardStep[WizardStep["Review"] = 9] = "Review";
})(WizardStep || (WizardStep = {}));
export var STEP_NAME = (_a = {}, _a[WizardStep.Queues] = 'queue', _a[WizardStep.WorkVolume] = 'workVolume', _a[WizardStep.ProdHours] = 'prodHours', _a[WizardStep.HandleTime] = 'handleTime', _a[WizardStep.Shrinkage] = 'shrinkage', _a[WizardStep.Attrition] = 'attrition', _a[WizardStep.WorkingDays] = 'workingDay', _a[WizardStep.SupportStaff] = 'supportStaff', _a[WizardStep.Financial] = 'financial', _a[WizardStep.Review] = 'review', _a);
export var STATUS_BY_STEP = (_b = {}, _b[WizardStep.Queues] = [], _b[WizardStep.WorkVolume] = [QueueStatusType.Volume, QueueStatusType.WAP], _b[WizardStep.ProdHours] = [QueueStatusType.Volume, QueueStatusType.WAP, QueueStatusType.WAT], _b[WizardStep.HandleTime] = [QueueStatusType.HandleTime], _b[WizardStep.Attrition] = [QueueStatusType.Attrition], _b[WizardStep.Shrinkage] = [QueueStatusType.Shrinkages], _b[WizardStep.WorkingDays] = [QueueStatusType.WorkingDays, QueueStatusType.FTEDay], _b);
export var DAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export var GENERAL_MONTH = -1;
export var PLAN_COLORS = [['#333366', '#D7E3F1'], ['#b25c03', '#f2d5b7'], ['#136a21', '#bce1c2'], ['#994f4f', '#e8cfd2'], ['#666633', '#e1e0cb'], ['#5c0276', '#dbd0f5']];
// Dynamic step configuration based on plan type category
export var getWorkflowSteps = function (planTypeCategory) {
  if (planTypeCategory === PlanTypeCategory.ProdHours) {
    // For Prod Hours: Queues, Prod Hours, Shrinkage, Attrition, Working Days, Support Staff, Financials, Review
    return [WizardStep.Queues, WizardStep.ProdHours, WizardStep.Shrinkage, WizardStep.Attrition, WizardStep.WorkingDays, WizardStep.SupportStaff, WizardStep.Financial, WizardStep.Review];
  } else {
    // For Work Volume: Queues, Work Volume, Handle Time, Shrinkage, Attrition, Working Days, Support Staff, Financials, Review
    return [WizardStep.Queues, WizardStep.WorkVolume, WizardStep.HandleTime, WizardStep.Shrinkage, WizardStep.Attrition, WizardStep.WorkingDays, WizardStep.SupportStaff, WizardStep.Financial, WizardStep.Review];
  }
};
export var getStepsLength = function (planTypeCategory) {
  return getWorkflowSteps(planTypeCategory).length;
};